<template>
    <div id="tableTourscope">
        <div class="myTable">
            <div class="table-responsive">
                <table class="table table-bordered m-0">
                    <thead class="colorTable">
                        <tr>
                            <th colspan="2"></th>
                            <th class="border-left isImage" v-for="item in operationData.operatorsSchema" :key="item.Name"  :colspan="colspan">
                                <img :src="'/acentaLogos/'+item.Name+'.png'" :alt="item.Name" />
                            </th>
                        </tr>
                        <tr>
                            <th v-if="operationData.Hotels.length==1">
                                Tarih
                            </th>
                            <th class="name" :colspan="operationData.Hotels.length==1?1:2">
                                Hotel
                            </th>
                            <template v-for="item in operationData.operatorsSchema" :key="item.Name">
                                <th v-if="priceShow.PP">
                                    PP
                                    <span v-if="item.summary.one.pp.cheap==null">
                                        0,00{{CurrencyCodeSymbol[CurrencyCode]}} ~ 0,00{{CurrencyCodeSymbol[CurrencyCode]}}
                                    </span>
                                    <span v-if="item.summary.one.pp.cheap!=null">
                                        {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.pp.cheap/100*(100-Commission):item.summary.one.pp.cheap),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                        ~
                                        {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.pp.expensive/100*(100-Commission):item.summary.one.pp.expensive),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                    </span>
                                </th>
                                <th v-if="priceShow.Daily">
                                    Daily
                                    <span v-if="item.summary.one.daily.cheap==null">
                                        0,00{{CurrencyCodeSymbol[CurrencyCode]}} ~ 0,00{{CurrencyCodeSymbol[CurrencyCode]}}
                                    </span>
                                    <span v-if="item.summary.one.daily.cheap!=null">
                                        {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.daily.cheap/100*(100-Commission):item.summary.one.daily.cheap),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                        ~
                                        {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.daily.expensive/100*(100-Commission):item.summary.one.daily.expensive),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                    </span>
                                </th>
                                <th v-if="priceShow.DBL">
                                    Package
                                    <span v-if="item.summary.one.dbl.cheap==null">
                                        0,00{{CurrencyCodeSymbol[CurrencyCode]}} ~ 0,00{{CurrencyCodeSymbol[CurrencyCode]}}
                                    </span>
                                    <span v-if="item.summary.one.dbl.cheap!=null">
                                        {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.dbl.cheap/100*(100-Commission):item.summary.one.dbl.cheap),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                        ~
                                        {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.dbl.expensive/100*(100-Commission):item.summary.one.dbl.expensive),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                    </span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="date in Object.entries(schema)" :key="date[0]">
                            <tr v-for="hotel,hIndex in Object.entries(date[1])" :key="hotel[0]" :title="$dateFormat(new Date(date[0])).substring(0,5)+' - '+hotel[1].Name">
                                <td class="nowrap" :class="{'date':operationData.Hotels.length>1}" :rowspan="Object.keys(date[1]).length" v-if="hIndex==0"><span>{{$dateFormat(new Date(date[0])).substring(0,5)}}</span></td>
                                <td class="border-left nowrap name">{{hotel[1].Name}}</td>
                                <template v-for="operator in operationData.operatorsSchema" :key="operator">
                                    <template v-if="hotel[1].oparators[operator.Id].pp>0 && hotel[1].oparators[operator.Id].pp!='X' && hotel[1].oparators[operator.Id].pp!=null">
                                        <td class="border-left nowrap" :class="colorize?hotel[1].oparators[operator.Id].color:''" @click="detailPrices={...hotel[1].oparators[operator.Id],hotelName:hotel[1].Name,hotelId:hotel[0],date:date[0]}" v-if="priceShow.PP">
                                            {{$formatPrice(
                                                isCommission?
                                                hotel[1].oparators[operator.Id].ppFormat/100*(100-Commission):
                                                hotel[1].oparators[operator.Id].ppFormat)
                                            }} {{CurrencyCodeSymbol[CurrencyCode]}}
                                        </td>
                                        <td class="nowrap" :class="colorize?hotel[1].oparators[operator.Id].color:''" @click="detailPrices={...hotel[1].oparators[operator.Id],hotelName:hotel[1].Name,hotelId:hotel[0],date:date[0]}" v-if="priceShow.Daily">
                                            {{$formatPrice(
                                                isCommission?
                                                hotel[1].oparators[operator.Id].dailyFormat/100*(100-Commission):
                                                hotel[1].oparators[operator.Id].dailyFormat)
                                            }} {{CurrencyCodeSymbol[CurrencyCode]}}
                                        </td>
                                        <td class="nowrap" :class="colorize?hotel[1].oparators[operator.Id].color:''" @click="detailPrices={...hotel[1].oparators[operator.Id],hotelName:hotel[1].Name,hotelId:hotel[0],date:date[0]}" v-if="priceShow.DBL">
                                            {{$formatPrice(
                                                isCommission?
                                                hotel[1].oparators[operator.Id].dblFormat/100*(100-Commission):
                                                hotel[1].oparators[operator.Id].dblFormat)
                                            }} {{CurrencyCodeSymbol[CurrencyCode]}}
                                        </td>
                                    </template>
                                    <template v-if="hotel[1].oparators[operator.Id].pp==-1">
                                        <td class="border-left tcenter" :colspan="colspan">
                                            -
                                        </td>
                                    </template>
                                    <template v-if="hotel[1].oparators[operator.Id].pp==null">
                                        <td class="border-left stop progress-bar bg-danger" @click="errorDetail={errors:hotel[1].oparators[operator.Id].errors,date:$dateFormat(new Date(date[0])),hotelName:hotel[1].Name,operatorName:hotel[1].oparators[operator.Id].Name}" :colspan="colspan">
                                            <div>
                                                ERROR
                                            </div>
                                        </td>
                                    </template>
                                    <template v-if="hotel[1].oparators[operator.Id].pp==0">
                                        <td class="border-left stop progress-bar bg-danger progress-bar-striped" :colspan="colspan">
                                            <div>
                                                STOP
                                            </div>
                                        </td>
                                    </template>
                                    <template v-if="hotel[1].oparators[operator.Id].pp=='X'">
                                        <td class="border-left stop progress-bar bg-warning progress-bar-striped" :colspan="colspan">
                                            <div>
                                                Listelenmiyor
                                            </div>
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr class="border" v-if="operationData.Hotels.length>1">
                                <td colspan="100000" class="p-0"></td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div ref="style" v-show="false">
            .head{
                background-color: #ddd;
                border:thin solid #ddd;
                border-bottom:thin solid #ddd;
                text-align:center;
            }
            .headLeft{
                background-color: #ddd;
                border:thin solid #ddd;
                border-bottom:thin solid #ddd;
                text-align:left;
            }
            .imgHead{
                text-align:center;
                vertical-align:middle;
                border-left:thin solid #ddd;
                background-color: #eee;
            }
            .imgHeadWidth{
                text-align:center;
                vertical-align:middle;
                border-left:thin solid #ddd;
                background-color: #eee;
                width:250px;
            }
            .date{
                text-align:left;
            }
            .border-body-left{
                text-align:left;
                border-left:thin solid #ddd;
                border-bottom:thin solid #ddd;
            }
            img{
                left:50%;
                position:relative;
            }
            table{
                vertical-align:middle;
                border-top:thin solid #ddd;
                border-left:thin solid #ddd;
                border-right:thin solid #ddd;
            }
            td{
                border:thin solid #ddd;
                text-align:center;
                vertical-align:middle;
            }
            .stop{
                border-left:thin solid #ddd;
                font-weight:bold;
                color:#fc4b6c;
                text-align:center;
            }
            .notList{
                border-left:thin solid #ddd;
                font-weight:bold;
                color:#ffb22b;
                text-align:center;
            }
            
            .orderColor1{
                background-color: #478732;
                color:#fff;
                border-top:thin solid #478732;
                border-left:thin solid #478732;
                border-right:thin solid #478732;
                border-bottom:thin solid #325e23;
            }
            .border-left-orderColor1{
                background-color: #478732;
                color:#fff;
                border-top:thin solid #478732;
                border-right:thin solid #478732;
                border-left:thin solid #325e23;
                border-bottom:thin solid #325e23;
            }
            .orderColor2{
                background-color: #789330;
                color:#fff;
                border-top:thin solid #789330;
                border-left:thin solid #789330;
                border-right:thin solid #789330;
                border-bottom:thin solid #546722;
            }
            .border-left-orderColor2{
                background-color: #789330;
                color:#fff;
                border-top:thin solid #789330;
                border-right:thin solid #789330;
                border-left:thin solid #546722;
                border-bottom:thin solid #546722;
            }
            .orderColor3{
                background-color: #b4a12e;
                color:#fff;
                border-top:thin solid #b4a12e;
                border-left:thin solid #b4a12e;
                border-right:thin solid #b4a12e;
                border-bottom:thin solid #7e7020;
            }
            .border-left-orderColor3{
                background-color: #b4a12e;
                color:#fff;
                border-top:thin solid #b4a12e;
                border-right:thin solid #b4a12e;
                border-left:thin solid #7e7020;
                border-bottom:thin solid #7e7020;
            }
            .orderColor4{
                background-color: #dfab2c;
                color:#fff;
                border-top:thin solid #dfab2c;
                border-left:thin solid #dfab2c;
                border-right:thin solid #dfab2c;
                border-bottom:thin solid #9c771f;
            }
            .border-left-orderColor4{
                background-color: #dfab2c;
                color:#fff;
                border-top:thin solid #dfab2c;
                border-right:thin solid #dfab2c;
                border-left:thin solid #9c771f;
                border-bottom:thin solid #9c771f;
            }
            .orderColor5{
                background-color: #ffb22b;
                color:#fff;
                border-top:thin solid #ffb22b;
                border-left:thin solid #ffb22b;
                border-right:thin solid #ffb22b;
                border-bottom:thin solid #b27c1e;
            }
            .border-left-orderColor5{
                background-color: #ffb22b;
                color:#fff;
                border-top:thin solid #ffb22b;
                border-right:thin solid #ffb22b;
                border-left:thin solid #b27c1e;
                border-bottom:thin solid #b27c1e;
            }
            .orderColor6{
                background-color: #fa9233;
                color:#fff;
                border-top:thin solid #fa9233;
                border-left:thin solid #fa9233;
                border-right:thin solid #fa9233;
                border-bottom:thin solid #af6624;
            }
            .border-left-orderColor6{
                background-color: #fa9233;
                color:#fff;
                border-top:thin solid #fa9233;
                border-right:thin solid #fa9233;
                border-left:thin solid #af6624;
                border-bottom:thin solid #af6624;
            }
            .orderColor7{
                background-color: #f4723a;
                color:#fff;
                border-top:thin solid #f4723a;
                border-left:thin solid #f4723a;
                border-right:thin solid #f4723a;
                border-bottom:thin solid #701424;
            }
            .border-left-orderColor7{
                background-color: #f4723a;
                color:#fff;
                border-top:thin solid #f4723a;
                border-right:thin solid #f4723a;
                border-left:thin solid #701424;
                border-bottom:thin solid #701424;
            }
            .orderColor8{
                background-color: #ef5640;
                color:#fff;
                border-top:thin solid #ef5640;
                border-left:thin solid #ef5640;
                border-right:thin solid #ef5640;
                border-bottom:thin solid #a73c2d;
            }
            .border-left-orderColor8{
                background-color: #ef5640;
                color:#fff;
                border-top:thin solid #ef5640;
                border-right:thin solid #eb4245;
                border-left:thin solid #a73c2d;
                border-bottom:thin solid #a73c2d;
            }
            .orderColor9{
                background-color: #eb4245;
                color:#fff;
                border-top:thin solid #eb4245;
                border-left:thin solid #eb4245;
                border-right:thin solid #eb4245;
                border-bottom:thin solid #a42e30;
            }
            .border-left-orderColor9{
                background-color: #eb4245;
                color:#fff;
                border-top:thin solid #eb4245;
                border-right:thin solid #eb4245;
                border-left:thin solid #a42e30;
                border-bottom:thin solid #a42e30;
            }
            .orderColor10{
                background-color: #e6294b;
                color:#fff;
                border-top:thin solid #e6294b;
                border-left:thin solid #e6294b;
                border-right:thin solid #e6294b;
                border-bottom:thin solid #a11d34;
            }
            .border-left-orderColor10{
                background-color: #e6294b;
                color:#fff;
                border-top:thin solid #e6294b;
                border-right:thin solid #e6294b;
                border-left:thin solid #a11d34;
                border-bottom:thin solid #a11d34;
            }
            .border{
                height:3px;
                background-color: #cccccc;
            }
        </div>
        <table class="table table-bordered m-0" ref="table" v-show="false" v-if="exportExcel!=null">
            <thead class="colorTable">
                <tr>
                    <th class="imgHead">
                    </th>
                    <th class="imgHead">
                    </th>
                    <template v-for="item in operationData.operatorsSchema" :key="item.Name">
                        <th height="40" class="imgHead" :colspan="colspan">
                            <img :src="'https://admin.naps.com.tr/acentaLogos/'+item.Name+'.png'" :alt="item.Name" />
                        </th>
                    </template>
                </tr>
                <tr>
                    <th class="headLeft">
                        Tarih
                    </th>
                    <th class="headLeft">
                        Hotel
                    </th>
                    <template v-for="item in operationData.operatorsSchema" :key="item.Name">
                        <th class="head" v-if="priceShow.PP">
                            PP
                            <br>
                            <span v-if="item.summary.one.pp.cheap==null">
                                0,00{{CurrencyCodeSymbol[CurrencyCode]}} ~ 0,00{{CurrencyCodeSymbol[CurrencyCode]}}
                            </span>
                            <span v-if="item.summary.one.pp.cheap!=null">
                                {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.pp.cheap/100*(100-Commission):item.summary.one.pp.cheap),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                ~
                                {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.pp.expensive/100*(100-Commission):item.summary.one.pp.expensive),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                            </span>
                        </th>
                        <th class="head" v-if="priceShow.Daily">
                            Daily
                            <br>
                            <span v-if="item.summary.one.daily.cheap==null">
                                0,00{{CurrencyCodeSymbol[CurrencyCode]}} ~ 0,00{{CurrencyCodeSymbol[CurrencyCode]}}
                            </span>
                            <span v-if="item.summary.one.daily.cheap!=null">
                                {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.daily.cheap/100*(100-Commission):item.summary.one.daily.cheap),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                ~
                                {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.daily.expensive/100*(100-Commission):item.summary.one.daily.expensive),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                            </span>
                        </th>
                        <th class="head" v-if="priceShow.DBL">
                            Package
                            <br>
                            <span v-if="item.summary.one.dbl.cheap==null">
                                0,00{{CurrencyCodeSymbol[CurrencyCode]}} ~ 0,00{{CurrencyCodeSymbol[CurrencyCode]}}
                            </span>
                            <span v-if="item.summary.one.dbl.cheap!=null">
                                {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.dbl.cheap/100*(100-Commission):item.summary.one.dbl.cheap),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                                ~
                                {{$formatPrice($exchangeCurrency({EUR:item.EUR,USD:item.USD},"TRY",(isCommission?item.summary.one.dbl.expensive/100*(100-Commission):item.summary.one.dbl.expensive),CurrencyCode,"TRY"))}}{{CurrencyCodeSymbol[CurrencyCode]}}
                            </span>
                        </th>
                    </template>
                </tr>
            </thead>
            
            <template v-for="(date,iDate) in Object.entries(schema)" :key="date[0]">
                <tr v-if="operationData.Hotels.length>1 && iDate>0">
                    <td :colspan="operationData.Operators.length*colspan+2" class="border"></td>
                </tr>
                <tr v-for="hotel in Object.entries(date[1])" :key="hotel[0]">
                    <td class="date">{{$dateFormat(new Date(date[0])).substring(0,5)}}</td>
                    <td class="border-body-left">{{hotel[1].Name}}</td>
                    <template v-for="operator in operationData.operatorsSchema" :key="operator">
                        <template v-if="hotel[1].oparators[operator.Id].pp>0 && hotel[1].oparators[operator.Id].pp!='X' && hotel[1].oparators[operator.Id].pp!=null">
                            <td :class="'border-left-'+(colorize?hotel[1].oparators[operator.Id].color:'')" v-if="priceShow.PP">
                                {{$formatPrice(
                                    isCommission?
                                    hotel[1].oparators[operator.Id].ppFormat/100*(100-Commission):
                                    hotel[1].oparators[operator.Id].ppFormat)
                                }} {{CurrencyCodeSymbol[CurrencyCode]}}
                            </td>
                            <td :class="colorize?hotel[1].oparators[operator.Id].color:''" v-if="priceShow.Daily">
                                {{$formatPrice(
                                    isCommission?
                                    hotel[1].oparators[operator.Id].dailyFormat/100*(100-Commission):
                                    hotel[1].oparators[operator.Id].dailyFormat)
                                }} {{CurrencyCodeSymbol[CurrencyCode]}}
                            </td>
                            <td  :class="colorize?hotel[1].oparators[operator.Id].color:''" v-if="priceShow.DBL">
                                {{$formatPrice(
                                    isCommission?
                                    hotel[1].oparators[operator.Id].dblFormat/100*(100-Commission):
                                    hotel[1].oparators[operator.Id].dblFormat)
                                }} {{CurrencyCodeSymbol[CurrencyCode]}}
                            </td>
                        </template>
                        <template v-if="hotel[1].oparators[operator.Id].pp==-1">
                            <td :colspan="colspan">
                                -
                            </td>
                        </template>
                        <template v-if="hotel[1].oparators[operator.Id].pp==null">
                            <td class="stop" :colspan="colspan">
                                ERROR
                            </td>
                        </template>
                        <template v-if="hotel[1].oparators[operator.Id].pp==0">
                            <td class="stop" :colspan="colspan">
                                STOP
                            </td>
                        </template>
                        <template v-if="hotel[1].oparators[operator.Id].pp=='X'">
                            <td class="notList" :colspan="colspan">
                                Listelenmiyor
                            </td>
                        </template>
                    </template>
                </tr>
            </template>
        </table>
    </div>
    
    <modal v-if="detailPrices!=null && setOperationData.filter(x=>{return x.OperatorId==detailPrices.Id && x.HotelId==detailPrices.hotelId && x.Checkin==detailPrices.date}).length>0" @close="detailPrices=null" size="lg"
        :title="detailPrices.hotelName+' - '+detailPrices.Name+' ('+$dateFormat(new Date(detailPrices.date))+')'">
        <template #content>
            <div class="myTable">
                <table class="table table-bordered m-0">
                    <thead>
                        <tr>
                            <th>Oda</th>
                            <th>Pansiyon</th>
                            <th>PP</th>
                            <th>Daily</th>
                            <th>Package</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in setOperationData.filter(x=>{return x.OperatorId==detailPrices.Id && x.HotelId==detailPrices.hotelId && x.Checkin==detailPrices.date}).sort((x,y)=>{return x.PP-y.PP})" :key="item.PP">
                            <td>{{item.DBLRoom}}</td>
                            <td>{{item.DBLMeal}}</td>
                            <td>
                                {{
                                $formatPrice($exchangeCurrency({EUR:detailPrices.EUR,USD:detailPrices.USD},detailPrices.currencyCode,(isCommission?item.PP/100*(100-Commission):item.PP),CurrencyCode,"TRY"))+" "+CurrencyCode
                                }}
                            </td>
                            <td>
                                {{
                                $formatPrice($exchangeCurrency({EUR:detailPrices.EUR,USD:detailPrices.USD},detailPrices.currencyCode,(isCommission?item.Daily/100*(100-Commission):item.Daily),CurrencyCode,"TRY"))+" "+CurrencyCode
                                }}
                            </td>
                            <td>
                                {{
                                $formatPrice($exchangeCurrency({EUR:detailPrices.EUR,USD:detailPrices.USD},detailPrices.currencyCode,(isCommission?item.Package/100*(100-Commission):item.Package),CurrencyCode,"TRY"))+" "+CurrencyCode
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </modal>
    <modal v-if="errorDetail!=null" @close="errorDetail=null" size="lg" :title="'Error Detail ('+errorDetail.date+'-'+errorDetail.operatorName+'-'+errorDetail.hotelName+')'">
        <template #content>
            <pre class="m-0 p-3">{{errorDetail.errors}}</pre>
        </template>
    </modal>
</template>

<script>
    export default {
        name:"one",
        props:["operationData","schema","CurrencyCode","Commission","priceShow","isCommission","colorize","colspan","exportExcel"],
        data(){
            return {
                CurrencyCodeSymbol:{
                    TRY:"₺",
                    EUR:"€",
                    USD:"$",
                    RUB:"₽"
                },
                detailPrices:null,
                errorDetail:null,
            }
        },
        watch:{
            exportExcel(){
                let timer=setInterval(()=>{
                    if(this.$refs.table!=undefined && this.$refs.style!=undefined){
                        this.$tableToExcel(this.$refs.table,this.$refs.style,'Rapor1')
                        clearInterval(timer);
                    }
                },1);
            }
        },
        computed:{
            setOperationData(){
                return this.operationData.Prices;
            }
        }
    }
</script>

<style>

</style>